export default __webpack_public_path__ + "0c8a4f647990ce4c532cd645a8603e51.svg";